export default __webpack_public_path__ + "static/media/019-boar.78861a55.svg";